var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_vm.loading || _vm.error ? _c('LoaderIcon', {
    attrs: {
      "error": _vm.error
    }
  }) : _c('div', [_c('BaseTitle', [_vm._v("Resources")]), _c('div', {
    staticClass: "d-flex"
  }, [_vm.resources.length ? _c('h4', {
    staticClass: "color-dark-gray font-weight-bold mx-auto"
  }, [_vm._v(" " + _vm._s(_vm.resources.length) + " results for "), _c('span', {
    staticClass: "color-primary-blue"
  }, [_vm._v("\"" + _vm._s(_vm.searchQuery.trim()) + "\"")]), _vm.searchCategory ? [_vm._v(" in "), _c('span', {
    staticClass: "color-primary-blue"
  }, [_vm._v(_vm._s(_vm._.startCase(_vm.searchCategory)))])] : _vm._e()], 2) : _vm._e(), !_vm.resources.length ? _c('h4', {
    staticClass: "color-dark-gray font-weight-bold mx-auto"
  }, [_vm._v(" No results for "), _c('span', {
    staticClass: "color-primary-blue"
  }, [_vm._v("\"" + _vm._s(_vm.searchQuery.trim()) + "\"")]), _vm.searchCategory ? [_vm._v(" in "), _c('span', {
    staticClass: "color-primary-blue"
  }, [_vm._v(_vm._s(_vm._.startCase(_vm.searchCategory)))])] : _vm._e()], 2) : _vm._e()]), _c('div', {
    class: _vm.$style.gridView
  }, _vm._l(_vm.getSearchResources, function (resource) {
    return _c('ResourceBlock', {
      key: resource.resourceId,
      class: _vm.$style.resourceBlock,
      attrs: {
        "resource": resource
      }
    });
  }), 1), _vm.isShowMoreButtonVisible ? _c('BaseButton', {
    class: _vm.$style.showMoreButton,
    on: {
      "click": _vm.showMoreResults
    }
  }, [_c('span', [_vm._v("Show More")])]) : _vm._e()], 1), _c('b-modal', {
    attrs: {
      "id": "view-resource-modal",
      "modal-class": ['right', 'modal-resource'],
      "hide-footer": "",
      "hide-header": "",
      "title": "BootstrapVue"
    }
  }, [_c('ModalResource', {
    attrs: {
      "toast-component": this.$bvToast
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }